import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email || busy) return;
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      // Always show the same message — the backend never confirms whether
      // the email is registered, so we don't either.
      setSent(true);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Something went wrong. Try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="forgot-password-page" className="max-w-md mx-auto px-6 py-24">
      <div className="label mb-6">Threshold</div>
      <h1 className="serif text-5xl text-foreground leading-tight">
        {sent ? "Watch for the messenger." : "Recover the way in."}
      </h1>
      <p className="mt-4 text-muted-foreground leading-relaxed">
        {sent
          ? "If that email is on Correlate, a reset link is on its way. It expires in one hour."
          : "Enter the email tied to your account. If it exists, we'll send a one-time reset link."}
      </p>

      {!sent && (
        <form onSubmit={onSubmit} className="space-y-8 mt-12">
          <div>
            <div className="label mb-3">Email</div>
            <input
              required
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoFocus
              data-testid="forgot-password-email"
              className="input-line w-full"
            />
          </div>
          <button
            type="submit"
            disabled={busy}
            data-testid="forgot-password-submit"
            className="btn-gold w-full disabled:opacity-40"
          >
            {busy ? "Sending…" : "Send reset link"}
          </button>
        </form>
      )}

      <div className="mt-10 text-center">
        <Link
          to="/login"
          data-testid="forgot-password-back"
          className="mono text-[11px] uppercase tracking-[0.2em] text-muted-foreground link-underline"
        >
          ← Back to sign in
        </Link>
      </div>
    </div>
  );
}
